import axios from 'axios'

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_LOCATION_API_ENDPOINT}/location/zipcode`,
  headers: {
    Accept: 'application/json',
  },
})

export default instance
